import { Stack, styled, useTheme } from "@mui/material";
import { stepsPaths } from "../../constants";
import { StepLabel } from "../../shared";
import { Step } from "./Step/Step";
import useMediaQuery from "@mui/material/useMediaQuery";

const StyledStepper = styled(Stack)(({ theme }) => ({
    // border: "1px solid",
    alignItems: "center",
    height: "36px",
    marginLeft: 0,
    // borderColor: theme.palette.grey[500],
    // '& > div':
    // {
    //     '&:hover': {
    //         cursor: 'pointer',
    //         '& > p': {
    //             color: theme.palette.primary.light
    //         }
    //     },
    //     '&::after': {
    //         content: '""',
    //         height: "25px",
    //         width: "25px",
    //         borderTop: '1px solid',
    //         borderRight: '1px solid',
    //         transform: 'rotate(45deg)',
    //         borderColor: theme.palette.grey[500]
    //     },
    //     '&:last-child': {
    //         paddingRight: "12px",
    //         '&:after': {
    //             content: '""',
    //             eight: 0,
    //             width: 0,
    //             border: 0,
    //         }
    //     }
    // },
}));

export const Steps = () => {
    const theme = useTheme();
    const matchesXL = useMediaQuery(theme.breakpoints.up("xl"));

    return (

        <StyledStepper direction="row" ml={matchesXL ? "90px" : "40px"}>
            {stepsPaths.map((path, stepIndex) => (
                <Step key={path} label={StepLabel[path]} path={path} stepIndex={stepIndex} />
            ))}
        </StyledStepper>
    );
};
